// 收货地址
import * as React from "react";
import Layout from "../Layout";
import Content from "./Content";
import InfoLayout from "../UserCenter/components/Layout";
import { useSelector } from "react-redux";
import { RootState } from "../../store/configureStore";

const Address: React.FC = () => {
  const {
    breadcrumbs = [
      {
        url: "/",
        title: "首页",
      },
      {
        url: "/account/address",
        title: "地址",
      },
    ],
  } = useSelector((state: RootState) => state.AddressPage);

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <InfoLayout>
        <Content />
      </InfoLayout>
    </Layout>
  );
};

export default Address;
